"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
var HttpStatusCodes_1 = require("./HttpStatusCodes");
var ValidationError_1 = require("./ValidationError");
var UnknownError = /** @class */ (function (_super) {
    __extends(UnknownError, _super);
    function UnknownError(customMessage) {
        var _this = _super.call(this, customMessage) || this;
        _this.customMessage = customMessage;
        _this.errorCode = HttpStatusCodes_1.httpStatusCodes.UNKNOWN_ERROR.statusCode;
        _this.errorType = HttpStatusCodes_1.httpStatusCodes.UNKNOWN_ERROR.errorType;
        _this.message = 'Unknown error.';
        Object.setPrototypeOf(_this, UnknownError.prototype);
        return _this;
    }
    UnknownError.prototype.serializeErrors = function () {
        return [
            {
                message: this.message,
                customMessage: this.customMessage || '',
                errorCode: this.errorCode,
                errorType: this.errorType,
            },
        ];
    };
    return UnknownError;
}(ValidationError_1.ValidationError));
exports.UnknownError = UnknownError;
